import { AST } from '@handlebars/parser';
import { getMustacheStatementFromStatement } from './getMustacheStatementFromStatement';
import { getMergeTagMustacheStatement } from './getMergeTagMustacheStatement';

export const getHandlebarsMergeTagFromStatement = (statement: AST.Statement | null) => {
  const mustacheStatement = getMustacheStatementFromStatement(statement);
  return getMergeTagMustacheStatement(mustacheStatement);
};
